<template>
  <ReportWrapper
    :is-downloading="isLoading"
    :disable-download="!selectedCustomer"
    @download="downloadPdf"
  >
    <template #prepend>
      <CustomerAutocomplete
        v-model="selectedCustomer"
        class="w-2/6 x-sm:w-full"
        placeholder="Customer"
        label=""
        customer
        hide-details
        :return-object="false"
        item-value="accountNumber"
      />
    </template>
  </ReportWrapper>
</template>

<script lang="ts">
import { defineAsyncComponent, defineComponent, ref } from 'vue';
import { useReports } from '@/composables/reports/useReports';
import { downloadFileByType } from '@/helpers/download';
import { DocumentTypes, OutputTypes } from '@/constants/reports';
import { useToast } from '@/composables/useToast';
import date from '@/extensions/filters/date';
import ReportWrapper from '@/components/reports/ReportWrapper.vue';

export default defineComponent({
  name: 'TransloadInventoryReport',
  components: {
    ReportWrapper,
    CustomerAutocomplete: defineAsyncComponent(
      () => import('@/components/autocomplete/CustomerAutocompleteComponent.vue')
    ),
  },
  setup() {
    const toast = useToast();
    const selectedCustomer = ref<string | null>(null);

    const { useDownloadInternalInventoryReport } = useReports();
    const { mutateAsync: downloadReport, isLoading } = useDownloadInternalInventoryReport();

    const downloadPdf = async () => {
      if (!selectedCustomer.value) return toast.info('Please select customer.');

      try {
        const { data } = await downloadReport({
          outputType: OutputTypes.XLSX,
          documentType: DocumentTypes.TRANSLOAD_INVENTORY,
          customer: selectedCustomer.value,
        });

        if (!data) return;

        downloadFileByType(
          data,
          `Transload Inventory Report ${date(new Date())}`,
          OutputTypes.XLSX
        );
      } catch (e) {
        console.log(e);
      }
    };

    return { selectedCustomer, downloadPdf, isLoading };
  },
});
</script>
